{
  "version": 1,
  "asset_id": "fd09c32b-2c29-42f2-bad2-f8053792c941",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/fd09c32b-2c29-42f2-bad2-f8053792c941/deliverables-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/fd09c32b-2c29-42f2-bad2-f8053792c941/deliverables-1280.webp",
  "original_filename": "deliverables-1280.webp",
  "size": 55056,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:25:51Z"
}
